<template>
  <WsMain>
    <WsCRUD
      v-if="isMounted"
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :showFields="showFields"
      :showExpand="false"
      :pageMode="true"
      :rowClickRead="true"
      :inRowBtnUpdate="false"
      :inRowBtnDelete="false"
      :filterSelects="filterSelects"
      :filterProps="filterProps"
      :isCreatable="false"
      :customUrlParams="customUrlParams"
      @filter-select="$_onFilterSelect($event)"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/act_idtf_update";
import idtfModel from "@/models/act_idtf_assignment";
export default {
  data: () => ({
    isMounted: false,
    modelName: model.modelName,
    label: model.label,
    fields: idtfModel.fields,
    filterSelects: [
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "idtf_status",
        defaultValue: "1",
        items: [
          {
            text: "鑑別中",
            value: "1",
          },
          {
            text: "已完成",
            value: "2,3",
          },
        ],
      },
    ],
    filterProps: {},
    showFields: [
      "act_version",
      "idtf_owners",
      "idtf_backups",
      "idtf_reviewers",
      "idtf_updated_admin",
      "idtf_updated_at",
    ],
    customUrlParams: {
      status: '2'
    },
  }),
  methods: {
    $_onFilterSelect($event) {
      this.filterProps = {
          ...$event,
        };
    },
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>